import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NeighborhoodService } from '../../../services/neighborhood.service';
import { MovementService } from '../../../services/movement.service';
import moment from 'moment';
import { Movement } from '../../../models/movement.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MovementModalComponent } from '../../../components/movement-modal/movement-modal.component';
import { ToastService } from '../../../services/toast.service';
import * as XLSX from 'xlsx';
import { UtilService } from '../../../services/util.service';
import { jsPDF } from "jspdf";
import { Table } from 'primeng/table';

@Component({
  selector: 'app-movements-page',
  templateUrl: './movements-page.component.html',
  styleUrl: './movements-page.component.scss'
})
export class MovementsPageComponent {

  public years: any[] = [];
  public months: any[] = [];

  public yearSelected?: number;
  public currentYear: any;

  public currentMonth: any;
  public monthSelected?: number;

  public movementsFilter: 'pendingExpenses' | 'pendingIncome' | null = null;
  public movementsFiltered: Movement[] = [];
  public movementsSearch: string = '';
  public movementsPeriodLoaded: string | null = null;

  @ViewChild('dt') public table?: Table;

  data: any;
  options: any;

  dataMonth: any;
  optionsMonth: any;

  constructor(
    public movementService: MovementService,
    public neighborhoodService: NeighborhoodService,
    private modalService: NgbModal,
    private router: Router,
    private toastService: ToastService,
    private utilService: UtilService
  ) {


  }

  ngOnInit() {

    if(this.neighborhoodService.currentNeighborhood) {

      this.getDataMonths();

    } else {

      this.neighborhoodService.subCurrentNeighborhood.subscribe(
        (neighborhood) => {
          if(neighborhood) {
            this.getDataMonths();
          }
        }
      );

    }

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
    
    this.data = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
            {
                label: 'My First dataset',
                backgroundColor: documentStyle.getPropertyValue('--blue-500'),
                borderColor: documentStyle.getPropertyValue('--blue-500'),
                data: [65, 59, 80, 81, 56, 55, 40]
            },
            {
                label: 'My Second dataset',
                backgroundColor: documentStyle.getPropertyValue('--pink-500'),
                borderColor: documentStyle.getPropertyValue('--pink-500'),
                data: [28, 48, 40, 19, 86, 27, 90]
            }
        ]
    };

    this.options = {
        maintainAspectRatio: false,
        aspectRatio: 0.68,
        plugins: {
            legend: {
                labels: {
                    color: textColor
                }
            },
            title: {
              display: true,
              text: 'Custom Chart Title'
            }
        },
        scales: {
            x: {
                ticks: {
                    color: textColorSecondary,
                    font: {
                        weight: 500
                    }
                },
                grid: {
                    color: surfaceBorder,
                    drawBorder: false
                }
            },
            y: {
                ticks: {
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder,
                    drawBorder: false
                }
            }

        }
    };

    this.dataMonth = {
      labels: ['Ingresos', 'Egresos', 'Cuentas por pagar'],
      datasets: [
          {
              data: [300, 50, 100],
              backgroundColor: [documentStyle.getPropertyValue('--blue-500'), documentStyle.getPropertyValue('--yellow-500'), documentStyle.getPropertyValue('--green-500')],
              hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-400'), documentStyle.getPropertyValue('--yellow-400'), documentStyle.getPropertyValue('--green-400')]
          }
      ]
    };


    this.optionsMonth = {
        maintainAspectRatio: false,
        aspectRatio: 0.68,
        cutout: '60%',
        plugins: {
            legend: {
                labels: {
                    color: textColor
                }
            },
            title: {
              display: true,
              text: 'Custom Chart Title'
            }
        }
    };

  }

  /*
  ██████╗ ███████╗██╗     ███████╗████████╗███████╗
  ██╔══██╗██╔════╝██║     ██╔════╝╚══██╔══╝██╔════╝
  ██║  ██║█████╗  ██║     █████╗     ██║   █████╗
  ██║  ██║██╔══╝  ██║     ██╔══╝     ██║   ██╔══╝
  ██████╔╝███████╗███████╗███████╗   ██║   ███████╗
  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚══════╝

  */
  async delete(movement: Movement) {

    const flag = confirm('¿Estás seguro de eliminar este movimiento?');

    if(flag) {
      const anotherFlag = await this.movementService.delete(
        movement
      );

      if(anotherFlag) {
        this.getMovements();
      }
    }

  }

  /*
  ██████╗  ██████╗ ██╗    ██╗███╗   ██╗██╗      ██████╗  █████╗ ██████╗ ██████╗ ███████╗██████╗  ██████╗ ██████╗ ████████╗
  ██╔══██╗██╔═══██╗██║    ██║████╗  ██║██║     ██╔═══██╗██╔══██╗██╔══██╗██╔══██╗██╔════╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝
  ██║  ██║██║   ██║██║ █╗ ██║██╔██╗ ██║██║     ██║   ██║███████║██║  ██║██████╔╝█████╗  ██████╔╝██║   ██║██████╔╝   ██║
  ██║  ██║██║   ██║██║███╗██║██║╚██╗██║██║     ██║   ██║██╔══██║██║  ██║██╔══██╗██╔══╝  ██╔═══╝ ██║   ██║██╔══██╗   ██║
  ██████╔╝╚██████╔╝╚███╔███╔╝██║ ╚████║███████╗╚██████╔╝██║  ██║██████╔╝██║  ██║███████╗██║     ╚██████╔╝██║  ██║   ██║
  ╚═════╝  ╚═════╝  ╚══╝╚══╝ ╚═╝  ╚═══╝╚══════╝ ╚═════╝ ╚═╝  ╚═╝╚═════╝ ╚═╝  ╚═╝╚══════╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝

  */
  downloadReport() {

    // const doc = new jsPDF();

    // doc.text("Hello world!", 10, 10);
    // doc.save("a4.pdf");

    // return;

    const data: any[] = [];

    data.push([
      'DESCRIPCIÓN',
      'NOTAS',
      'FECHA',
      'INGRESO/EGRESO',
      'ESTADO',
      'MONTO'
    ]);

    this.movementService.movements.forEach(
      (movement, index) => {

        data.push([
          movement.description,
          movement.notes,
          moment(movement.createdAt).format('DD/MM/YYYY'),
          movement.movementType 
            ? 'Ingreso' 
            : 'Egreso',
          movement.statusDescription,
          movement.movementType
            ? movement.amount
            : -movement.amount
        ]);

      }
    );

    data.push([
      '',
      '',
      '',
      '',
      '',
      ''
    ]);

    data.push([
      'Cuentas por pagar',
      '',
      '',
      '',
      '',
      -this.movementService.insights!.monthBalance!.pendingExpenses
    ]);

    data.push([
      'Cobros pendientes',
      '',
      '',
      '',
      '',
      this.movementService.insights?.monthBalance?.pendingIncome
    ]);

    data.push([
      'Ingresos',
      '',
      '',
      '',
      '',
      this.movementService.insights?.monthBalance?.income
    ]);

    data.push([
      'Egresos',
      '',
      '',
      '',
      '',
      -this.movementService.insights!.monthBalance!.expenses
    ]);

    data.push([
      'En caja',
      '',
      '',
      '',
      '',
      this.movementService.insights!.totalBalance!.balance - this.movementService.insights!.monthBalance!.balance
    ]);

    data.push([
      'BALANCE NETO DEL MES',
      '',
      '',
      '',
      '',
      this.movementService.insights?.monthBalance?.balance
    ]);

    // data.push([
    //   'EN CAJA',
    //   '',
    //   '',
    //   '',
    //   '',
    //   this.movementService.insights?.lastMonthBalance?.balance
    // ]);

    data.push([
      'BALANCE TOTAL',
      '',
      '',
      '',
      '',
      this.movementService.insights?.totalBalance?.balance
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet(data);

    const columnWidths = data[1].map((_: any, colIndex: string | number) => {
      const maxLength = data.reduce((max, row) => {
        const cell = row[colIndex];
        const cellLength = cell ? cell.toString().length : 0;
        return Math.max(max, cellLength);
      }, 0);
      return { wch: maxLength + 2 }; // Ajuste adicional para margen
    });

    // Asignar los anchos de columna al worksheet
      worksheet['!cols'] = columnWidths;
  
      // Crear un libro de trabajo y agregar la hoja
      const workbook = XLSX.utils.book_new();

      console.log(
        this.currentMonth
      );
      

      XLSX.utils.book_append_sheet(
        workbook, 
        worksheet, 
        `${this.currentMonth?.description} ${this.yearSelected}`
      );
  
      // Exportar el archivo XLSX
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  
      // Crear un Blob para la descarga
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  
      // Crear un enlace de descarga
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
  
      // Asignar el nombre del archivo
      link.download = `${this.neighborhoodService.currentNeighborhood?.name}-estado-de-cuenta-${this.currentMonth?.description}-${this.yearSelected}.xlsx`;
  
      // Disparar la descarga
        link.click();

  }

  /*
   ██████╗ ███████╗████████╗██████╗  █████╗ ████████╗ █████╗ ███╗   ███╗ ██████╗ ███╗   ██╗████████╗██╗  ██╗███████╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗████╗ ████║██╔═══██╗████╗  ██║╚══██╔══╝██║  ██║██╔════╝
  ██║  ███╗█████╗     ██║   ██║  ██║███████║   ██║   ███████║██╔████╔██║██║   ██║██╔██╗ ██║   ██║   ███████║███████╗
  ██║   ██║██╔══╝     ██║   ██║  ██║██╔══██║   ██║   ██╔══██║██║╚██╔╝██║██║   ██║██║╚██╗██║   ██║   ██╔══██║╚════██║
  ╚██████╔╝███████╗   ██║   ██████╔╝██║  ██║   ██║   ██║  ██║██║ ╚═╝ ██║╚██████╔╝██║ ╚████║   ██║   ██║  ██║███████║
   ╚═════╝ ╚══════╝   ╚═╝   ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝╚═╝     ╚═╝ ╚═════╝ ╚═╝  ╚═══╝   ╚═╝   ╚═╝  ╚═╝╚══════╝

  */
  getDataMonths() {
    const createdAt = new Date(
      this.neighborhoodService.currentNeighborhood!.createdAt
    );
    const startDate = new Date(
      createdAt.getFullYear(), createdAt.getMonth(), 1
    );
    
    const endDate = new Date();

    endDate.setMonth(endDate.getMonth());

    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;
      const description = moment(currentDate).format('MMMM');

      let yearObj = this.years.find(y => y.year === year) as any;
      if (!yearObj) {
        yearObj = { year, months: [] };
        this.years.push(yearObj);
      }

      yearObj.months.push({ month, description });
      currentDate.setMonth(currentDate.getMonth() + 1);
    }

    console.log(this.years);

    this.currentYear = this.years.find(y => y.year === endDate.getFullYear());
    this.yearSelected = this.currentYear.year;
    this.months = this.currentYear.months;
    this.currentMonth = this.currentYear.months.find(
      (m: any) => m.month === endDate.getMonth() + 1
    ) ?? this.currentYear.months[this.currentYear.months.length - 1];
    this.monthSelected = this.currentMonth.month;

    console.log(this.currentYear);
    console.log(this.currentMonth);

    console.log('Antes de get data');

    this.getMovements();
  }

  /*
   ██████╗ ███████╗████████╗███╗   ███╗ ██████╗ ██╗   ██╗███████╗███╗   ███╗███████╗███╗   ██╗████████╗███████╗
  ██╔════╝ ██╔════╝╚══██╔══╝████╗ ████║██╔═══██╗██║   ██║██╔════╝████╗ ████║██╔════╝████╗  ██║╚══██╔══╝██╔════╝
  ██║  ███╗█████╗     ██║   ██╔████╔██║██║   ██║██║   ██║█████╗  ██╔████╔██║█████╗  ██╔██╗ ██║   ██║   ███████╗
  ██║   ██║██╔══╝     ██║   ██║╚██╔╝██║██║   ██║╚██╗ ██╔╝██╔══╝  ██║╚██╔╝██║██╔══╝  ██║╚██╗██║   ██║   ╚════██║
  ╚██████╔╝███████╗   ██║   ██║ ╚═╝ ██║╚██████╔╝ ╚████╔╝ ███████╗██║ ╚═╝ ██║███████╗██║ ╚████║   ██║   ███████║
   ╚═════╝ ╚══════╝   ╚═╝   ╚═╝     ╚═╝ ╚═════╝   ╚═══╝  ╚══════╝╚═╝     ╚═╝╚══════╝╚═╝  ╚═══╝   ╚═╝   ╚══════╝

  */
   async getMovements() {
    
    if(
      this.yearSelected &&
      this.monthSelected
    ) {

      console.log(
        this.yearSelected
      );
      
      console.log(
        this.monthSelected
      );

      this.currentMonth = this.currentYear.months.find(
        (m: any) => m.month === this.monthSelected! + 1
      ) ?? this.currentYear.months[this.currentYear.months.length - 1];

      console.log(
        this.currentMonth
      );
      

      const movementsPeriod = `${this.yearSelected}-${this.monthSelected}`;

      if(
        this.movementsPeriodLoaded &&
        this.movementsPeriodLoaded !== movementsPeriod
      ) {

        this.movementsFilter = null;
        this.movementsSearch = '';

        if(this.table) {
          this.table.first = 0;
        }

      }

      this.movementsPeriodLoaded = movementsPeriod;

      await this.movementService.getAll(
        this.neighborhoodService.currentNeighborhood!.neighborhoodId,
        this.monthSelected!,
        this.yearSelected!,
      );

      this.applyMovementsFilter();

    } else {

      this.toastService.show({
        header: 'Error',
        body: 'Seleccione un mes y un año',
        classname: 'bg-danger text-white'
      });

    }

  }

  /*
   ██████╗ ███╗   ██╗ ██████╗██╗  ██╗ █████╗ ███╗   ██╗ ██████╗ ███████╗██╗   ██╗███████╗ █████╗ ██████╗
  ██╔═══██╗████╗  ██║██╔════╝██║  ██║██╔══██╗████╗  ██║██╔════╝ ██╔════╝╚██╗ ██╔╝██╔════╝██╔══██╗██╔══██╗
  ██║   ██║██╔██╗ ██║██║     ███████║███████║██╔██╗ ██║██║  ███╗█████╗   ╚████╔╝ █████╗  ███████║██████╔╝
  ██║   ██║██║╚██╗██║██║     ██╔══██║██╔══██║██║╚██╗██║██║   ██║██╔══╝    ╚██╔╝  ██╔══╝  ██╔══██║██╔══██╗
  ╚██████╔╝██║ ╚████║╚██████╗██║  ██║██║  ██║██║ ╚████║╚██████╔╝███████╗   ██║   ███████╗██║  ██║██║  ██║
   ╚═════╝ ╚═╝  ╚═══╝ ╚═════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚══════╝   ╚═╝   ╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝

  */
  onChangeYear(year: any) {

    console.log(year);

    if(year) {
      
      this.months = year.months;
      console.log(this.months);
      this.currentMonth = null;

    } else {

      this.months = [];
      this.currentMonth = null;

    }

    console.log(
      this.currentYear
    );

    console.log('onChangeYear');

  }

  /*
   ██████╗ ██████╗ ███████╗███╗   ██╗
  ██╔═══██╗██╔══██╗██╔════╝████╗  ██║
  ██║   ██║██████╔╝█████╗  ██╔██╗ ██║
  ██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║
  ╚██████╔╝██║     ███████╗██║ ╚████║
   ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝

  */
  open(movement?: Movement) {

    const modalRef = this.modalService.open(
      MovementModalComponent
    );

    modalRef.componentInstance.movement = movement;
    modalRef.componentInstance.neighborhoodId = this.neighborhoodService.currentNeighborhood!.neighborhoodId;

    if(!movement) {
      modalRef.componentInstance.yearSelected = this.yearSelected;
      modalRef.componentInstance.monthSelected = this.monthSelected;
    }

    modalRef.closed.subscribe(
      async () => {
    
        this.getMovements();

      }
    );

  }

  /*
   ██████╗ █████╗ ███╗   ██╗ ██████╗ ██████╗ ███████╗███╗   ██╗
  ██╔════╝██╔══██╗████╗  ██║██╔═══██╗██╔══██╗██╔════╝████╗  ██║
  ██║     ███████║██╔██╗ ██║██║   ██║██████╔╝█████╗  ██╔██╗ ██║
  ██║     ██╔══██║██║╚██╗██║██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║
  ╚██████╗██║  ██║██║ ╚████║╚██████╔╝██║     ███████╗██║ ╚████║
   ╚═════╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝

  */
  // region canOpenHousesWithCredit
  get canOpenHousesWithCredit(): boolean {

    if(this.movementService.loading) {
      return false;
    }

    if(!this.neighborhoodService.currentNeighborhood) {
      return false;
    }

    return (this.movementService.creditSummary?.housesWithCredit ?? 0) > 0;

  }

  get creditCardRole(): string | null {
    return this.canOpenHousesWithCredit
      ? 'button'
      : null;
  }

  get creditCardTabIndex(): number | null {
    return this.canOpenHousesWithCredit
      ? 0
      : null;
  }

  get creditCardAriaLabel(): string | null {
    return this.canOpenHousesWithCredit
      ? 'Ver casas con crédito'
      : null;
  }

  /*
   ██████╗██████╗ ███████╗██████╗ ██╗████████╗███████╗
  ██╔════╝██╔══██╗██╔════╝██╔══██╗██║╚══██╔══╝██╔════╝
  ██║     ██████╔╝█████╗  ██║  ██║██║   ██║   ███████╗
  ██║     ██╔══██╗██╔══╝  ██║  ██║██║   ██║   ╚════██║
  ╚██████╗██║  ██║███████╗██████╔╝██║   ██║   ███████║
   ╚═════╝╚═╝  ╚═╝╚══════╝╚═════╝ ╚═╝   ╚═╝   ╚══════╝

  */
  // region goToHousesWithCredit
  goToHousesWithCredit(event?: Event) {

    if(!this.canOpenHousesWithCredit) {
      return;
    }

    if(event) {

      if(event.target !== event.currentTarget) {
        return;
      }

      event.preventDefault();

    }

    this.router.navigate(
      [
        '/neighborhoods',
        this.neighborhoodService.currentNeighborhood!.neighborhoodId,
        'movements',
        'credits'
      ]
    );

  }

  /*
   ██████╗ █████╗ ███╗   ██╗███████╗██╗██╗     ████████╗███████╗██████╗
  ██╔════╝██╔══██╗████╗  ██║██╔════╝██║██║     ╚══██╔══╝██╔════╝██╔══██╗
  ██║     ███████║██╔██╗ ██║█████╗  ██║██║        ██║   █████╗  ██████╔╝
  ██║     ██╔══██║██║╚██╗██║██╔══╝  ██║██║        ██║   ██╔══╝  ██╔══██╗
  ╚██████╗██║  ██║██║ ╚████║██║     ██║███████╗   ██║   ███████╗██║  ██║
   ╚═════╝╚═╝  ╚═╝╚═╝  ╚═══╝╚═╝     ╚═╝╚══════╝   ╚═╝   ╚══════╝╚═╝  ╚═╝

  */
  // region canFilterPendingExpenses
  get canFilterPendingExpenses(): boolean {

    if(this.movementService.loading) {
      return false;
    }

    return (this.movementService.insights?.monthBalance?.pendingExpenses ?? 0) > 0;

  }

  get isPendingExpensesFilterActive(): boolean {
    return this.movementsFilter === 'pendingExpenses';
  }

  get pendingExpensesCardRole(): string | null {
    return this.canFilterPendingExpenses
      ? 'button'
      : null;
  }

  get pendingExpensesCardTabIndex(): number | null {
    return this.canFilterPendingExpenses
      ? 0
      : null;
  }

  get pendingExpensesCardAriaLabel(): string | null {
    return this.canFilterPendingExpenses
      ? 'Filtrar el estado de cuenta por egresos pendientes'
      : null;
  }

  get pendingExpensesCardAriaPressed(): string | null {

    if(!this.canFilterPendingExpenses) {
      return null;
    }

    return this.isPendingExpensesFilterActive
      ? 'true'
      : 'false';

  }

  // region canFilterPendingIncome
  get canFilterPendingIncome(): boolean {

    if(this.movementService.loading) {
      return false;
    }

    return (this.movementService.insights?.monthBalance?.pendingIncome ?? 0) > 0;

  }

  get isPendingIncomeFilterActive(): boolean {
    return this.movementsFilter === 'pendingIncome';
  }

  get pendingIncomeCardRole(): string | null {
    return this.canFilterPendingIncome
      ? 'button'
      : null;
  }

  get pendingIncomeCardTabIndex(): number | null {
    return this.canFilterPendingIncome
      ? 0
      : null;
  }

  get pendingIncomeCardAriaLabel(): string | null {
    return this.canFilterPendingIncome
      ? 'Filtrar el estado de cuenta por ingresos pendientes'
      : null;
  }

  get pendingIncomeCardAriaPressed(): string | null {

    if(!this.canFilterPendingIncome) {
      return null;
    }

    return this.isPendingIncomeFilterActive
      ? 'true'
      : 'false';

  }

  /*
  ███████╗██╗██╗     ████████╗███████╗██████╗
  ██╔════╝██║██║     ╚══██╔══╝██╔════╝██╔══██╗
  █████╗  ██║██║        ██║   █████╗  ██████╔╝
  ██╔══╝  ██║██║        ██║   ██╔══╝  ██╔══██╗
  ██║     ██║███████╗   ██║   ███████╗██║  ██║
  ╚═╝     ╚═╝╚══════╝   ╚═╝   ╚══════╝╚═╝  ╚═╝

  */
  // region applyMovementsFilter
  applyMovementsFilter() {

    const movements = this.movementService.movements;

    let filtered: Movement[];

    if(this.movementsFilter === 'pendingExpenses') {

      filtered = movements.filter(
        (movement) => movement.paymentMethodCode !== 'credit' &&
          !movement.movementType &&
          !movement.status
      );

    } else if(this.movementsFilter === 'pendingIncome') {

      filtered = movements.filter(
        (movement) => movement.paymentMethodCode !== 'credit' &&
          movement.movementType &&
          !movement.status
      );

    } else {

      filtered = [...movements];

    }

    const tokens = this.buildMovementsSearchTokens();

    if(tokens.length > 0) {

      filtered = filtered.filter(
        (movement) => this.matchesMovementsSearch(
          movement,
          tokens
        )
      );

    }

    this.movementsFiltered = filtered;

  }

  /*
  ███╗   ██╗ ██████╗ ██████╗ ███╗   ███╗ █████╗ ██╗     ██╗███████╗███████╗
  ████╗  ██║██╔═══██╗██╔══██╗████╗ ████║██╔══██╗██║     ██║╚══███╔╝██╔════╝
  ██╔██╗ ██║██║   ██║██████╔╝██╔████╔██║███████║██║     ██║  ███╔╝ █████╗
  ██║╚██╗██║██║   ██║██╔══██╗██║╚██╔╝██║██╔══██║██║     ██║ ███╔╝  ██╔══╝
  ██║ ╚████║╚██████╔╝██║  ██║██║ ╚═╝ ██║██║  ██║███████╗██║███████╗███████╗
  ╚═╝  ╚═══╝ ╚═════╝ ╚═╝  ╚═╝╚═╝     ╚═╝╚═╝  ╚═╝╚══════╝╚═╝╚══════╝╚══════╝

  */
  // region normalizeSearchText
  normalizeSearchText(value: string): string {

    return (value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

  }

  /*
  ████████╗ ██████╗ ██╗  ██╗███████╗███╗   ██╗███████╗
  ╚══██╔══╝██╔═══██╗██║ ██╔╝██╔════╝████╗  ██║██╔════╝
     ██║   ██║   ██║█████╔╝ █████╗  ██╔██╗ ██║███████╗
     ██║   ██║   ██║██╔═██╗ ██╔══╝  ██║╚██╗██║╚════██║
     ██║   ╚██████╔╝██║  ██╗███████╗██║ ╚████║███████║
     ╚═╝    ╚═════╝ ╚═╝  ╚═╝╚══════╝╚═╝  ╚═══╝╚══════╝

  */
  // region buildMovementsSearchTokens
  buildMovementsSearchTokens(): string[] {

    return this.normalizeSearchText(this.movementsSearch)
      .trim()
      .split(/\s+/)
      .filter(
        (token) => token.length > 0
      );

  }

  /*
  ████████╗███████╗██╗  ██╗████████╗
  ╚══██╔══╝██╔════╝╚██╗██╔╝╚══██╔══╝
     ██║   █████╗   ╚███╔╝    ██║
     ██║   ██╔══╝   ██╔██╗    ██║
     ██║   ███████╗██╔╝ ██╗   ██║
     ╚═╝   ╚══════╝╚═╝  ╚═╝   ╚═╝

  */
  // region buildMovementSearchText
  buildMovementSearchText(movement: Movement): string {

    const timeZone = this.neighborhoodService.currentNeighborhood?.timeZone;

    const date = movement.createdAt
      ? moment(movement.createdAt).add(timeZone ?? 0, 'hours').format('DD MMM yyyy')
      : '';

    const amount = movement.amount ?? 0;

    const amountFormatted = amount.toLocaleString(
      'en-US',
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    );

    const parts: string[] = [
      movement.description ?? '',
      movement.notes ?? '',
      movement.statusDescription,
      movement.paymentMethod?.name ?? '',
      date,
      `${amount}`,
      amountFormatted
    ];

    return this.normalizeSearchText(
      parts.join(' ')
    );

  }

  /*
  ███╗   ███╗ █████╗ ████████╗ ██████╗██╗  ██╗███████╗███████╗
  ████╗ ████║██╔══██╗╚══██╔══╝██╔════╝██║  ██║██╔════╝██╔════╝
  ██╔████╔██║███████║   ██║   ██║     ███████║█████╗  ███████╗
  ██║╚██╔╝██║██╔══██║   ██║   ██║     ██╔══██║██╔══╝  ╚════██║
  ██║ ╚═╝ ██║██║  ██║   ██║   ╚██████╗██║  ██║███████╗███████║
  ╚═╝     ╚═╝╚═╝  ╚═╝   ╚═╝    ╚═════╝╚═╝  ╚═╝╚══════╝╚══════╝

  */
  // region matchesMovementsSearch
  matchesMovementsSearch(
    movement: Movement,
    tokens: string[]
  ): boolean {

    if(tokens.length === 0) {
      return true;
    }

    const text = this.buildMovementSearchText(movement);

    return tokens.every(
      (token) => text.includes(token)
    );

  }

  /*
   ██████╗ ███╗   ██╗███████╗███████╗ █████╗ ██████╗  ██████╗██╗  ██╗
  ██╔═══██╗████╗  ██║██╔════╝██╔════╝██╔══██╗██╔══██╗██╔════╝██║  ██║
  ██║   ██║██╔██╗ ██║███████╗█████╗  ███████║██████╔╝██║     ███████║
  ██║   ██║██║╚██╗██║╚════██║██╔══╝  ██╔══██║██╔══██╗██║     ██╔══██║
  ╚██████╔╝██║ ╚████║███████║███████╗██║  ██║██║  ██║╚██████╗██║  ██║
   ╚═════╝ ╚═╝  ╚═══╝╚══════╝╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝ ╚═════╝╚═╝  ╚═╝

  */
  // region onMovementsSearchChange
  onMovementsSearchChange(value: string) {

    this.movementsSearch = value ?? '';

    this.applyMovementsFilter();

    if(this.table) {
      this.table.first = 0;
    }

  }

  // region clearMovementsSearch
  clearMovementsSearch(input?: HTMLInputElement) {

    this.onMovementsSearchChange('');

    if(input) {
      input.focus();
    }

  }

  /*
  ████████╗ ██████╗  ██████╗  ██████╗ ██╗     ███████╗
  ╚══██╔══╝██╔═══██╗██╔════╝ ██╔════╝ ██║     ██╔════╝
     ██║   ██║   ██║██║  ███╗██║  ███╗██║     █████╗
     ██║   ██║   ██║██║   ██║██║   ██║██║     ██╔══╝
     ██║   ╚██████╔╝╚██████╔╝╚██████╔╝███████╗███████╗
     ╚═╝    ╚═════╝  ╚═════╝  ╚═════╝ ╚══════╝╚══════╝

  */
  // region toggleMovementsFilter
  toggleMovementsFilter(
    filter: 'pendingExpenses' | 'pendingIncome',
    event?: Event
  ) {

    if(filter === 'pendingExpenses' && !this.canFilterPendingExpenses) {
      return;
    }

    if(filter === 'pendingIncome' && !this.canFilterPendingIncome) {
      return;
    }

    if(event) {

      if(event.target !== event.currentTarget) {
        return;
      }

      event.preventDefault();

    }

    this.movementsFilter = this.movementsFilter === filter
      ? null
      : filter;

    this.applyMovementsFilter();

    if(this.table) {
      this.table.first = 0;
    }

  }

  /*
   ██████╗██╗     ███████╗ █████╗ ██████╗
  ██╔════╝██║     ██╔════╝██╔══██╗██╔══██╗
  ██║     ██║     █████╗  ███████║██████╔╝
  ██║     ██║     ██╔══╝  ██╔══██║██╔══██╗
  ╚██████╗███████╗███████╗██║  ██║██║  ██║
   ╚═════╝╚══════╝╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝

  */
  // region hasColumnFilterValue
  hasColumnFilterValue(): boolean {

    const filters = this.table?.filters;

    if(!filters) {
      return false;
    }

    return Object.keys(filters).some(
      (key) => {

        const metadata = filters[key];

        const constraints = Array.isArray(metadata)
          ? metadata
          : [metadata];

        return constraints.some(
          (constraint) => {

            const value = constraint?.value;

            if(value === null || value === undefined || value === '') {
              return false;
            }

            if(Array.isArray(value)) {
              return value.length > 0;
            }

            return true;

          }
        );

      }
    );

  }

  // region canClearMovementsFilter
  get canClearMovementsFilter(): boolean {

    if(this.movementService.loading) {
      return false;
    }

    if(this.movementsFilter) {
      return true;
    }

    if(this.movementsSearch.trim().length > 0) {
      return true;
    }

    if(!this.table) {
      return false;
    }

    if(this.hasColumnFilterValue()) {
      return true;
    }

    return !!this.table.sortField;

  }

  // region clearMovementsFilter
  clearMovementsFilter() {

    this.movementsFilter = null;
    this.movementsSearch = '';

    this.applyMovementsFilter();

    if(this.table) {

      this.table.clear();
      this.table.first = 0;

    }

  }

}
